import {
  ADD_TO_TICKETS,
  REMOVE_FROM_TICKETS,
  INCREASE,
  DECREASE,
  ADD_TOTAL,
  ORDER_TYPE,
  RESET,
  DISCOUNT_AMOUNT,
  DISCOUNT_TYPE,
} from "../../actions/types";
const items = localStorage.getItem("tickets");
const total = localStorage.getItem("total");
const initialState = {
  orderType: "pickup",
  discountType: "",
  discountAmount: 0,
  total: total ? parseInt(total).toFixed(2) : 0,
  ticketItems: items ? JSON.parse(items) : [],
};

export const ticketReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case ADD_TO_TICKETS:
      const item = action.payload;
      // console.log("item", item);

      const isExist = state.ticketItems.find(
        (singleItem: any) => singleItem.ItemCode === item.ItemCode
      );

      if (isExist) {
        //console.log("item already exist");
        return {
          ...state,

          ticketItems: state.ticketItems.map((singleItem: any) =>
            singleItem.ItemCode === item.ItemCode
              ? { ...singleItem, ItemQuantity: singleItem.ItemQuantity + 1 }
              : singleItem
          ),
        };
      } else {
        //  console.log("item not exist");
        const newItem = { ...item, ItemQuantity: 1 };
        return {
          ...state,
          ticketItems: [...state.ticketItems, newItem],
        };
      }

    case REMOVE_FROM_TICKETS:
      return {
        ...state,
        ticketItems: state.ticketItems.filter(
          (singleItem: any) => singleItem.ItemCode !== action.payload
        ),
      };

    case DECREASE:
      const itemToReduce = action.payload;
      const isItemExist = state.ticketItems.find(
        (item: any) => item.ItemCode === itemToReduce.ItemCode
      );
      // console.log("isItemExist", isItemExist);
      // console.log("itemToReduce", itemToReduce);

      if (isItemExist) {
        //  console.log("item already exist");
        if (itemToReduce.ItemQuantity > 1) {
          // console.log("reduce quantity");
          return {
            ...state,
            ticketItems: state.ticketItems.map((singleItem: any) =>
              singleItem.ItemCode === itemToReduce.ItemCode
                ? { ...singleItem, ItemQuantity: singleItem.ItemQuantity - 1 }
                : singleItem
            ),
          };
        } else {
          // console.log("remove item");
          return {
            ...state,
            ticketItems: state.ticketItems.filter(
              (item: any) => item.ItemCode !== itemToReduce.ItemCode
            ),
          };
        }
      }
      break;

    case ADD_TOTAL:
      return {
        ...state,
        total: action.payload,
      };
    case ORDER_TYPE:
      return {
        ...state,
        orderType: action.payload,
      };

    case DISCOUNT_TYPE:
      return {
        ...state,
        discountType: action.payload,
      };
    case DISCOUNT_AMOUNT:
      return {
        ...state,
        discountAmount: action.payload,
      };

    case RESET:
      return {
        ...state,
        ticketItems: [],
        total: 0,
        orderType: "pickup",
        discountType: "",
        discountAmount: 0,
      };
    default:
      return state;
  }
};
